import { LOGO_ICON } from './brandIcon.constants';

export const getLogoIcon = () => LOGO_ICON;
